module.exports = __webpack_public_path__ + "static/media/checkbox-inside.707a62ac.svg";